"use strict";

!function (t) {
  function n(r) {
    if (e[r]) return e[r].exports;
    var i = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
  }

  var e = {};
  return n.m = t, n.c = e, n.i = function (t) {
    return t;
  }, n.d = function (t, n, e) {
    Object.defineProperty(t, n, {
      configurable: !1,
      enumerable: !0,
      get: e
    });
  }, n.o = function (t, n) {
    return Object.prototype.hasOwnProperty.call(t, n);
  }, n.p = "", n(n.s = 1);
}([function (t, n) {
  var e;

  e = function () {
    return this;
  }();

  try {
    e = e || Function("return this")() || (0, eval)("this");
  } catch (r) {
    "object" == typeof window && (e = window);
  }

  t.exports = e;
}, function (t, n, e) {
  "use strict";

  (function (t) {
    function n(t, n) {
      if (t !== n) throw new TypeError("Cannot instantiate an arrow function");
    }

    function e(t, n) {
      for (var e = Object.assign({}, t), r = Object.keys(n), i = Array.isArray(r), o = 0, r = i ? r : r[Symbol.iterator]();;) {
        var u;

        if (i) {
          if (o >= r.length) break;
          u = r[o++];
        } else {
          if (o = r.next(), o.done) break;
          u = o.value;
        }

        var a = u;
        t[a] = n[a](e);
      }
    }

    function r(e) {
      var r = this;
      
      if (!t.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
        t.__REACT_DEVTOOLS_GLOBAL_HOOK__ = {
            inject: () => {},
            supportsFiber: true,
            onCommitFiberRoot: () => {},
        };
      }
      try {
        t.__REACT_DEVTOOLS_GLOBAL_HOOK__ = t.parent.__REACT_DEVTOOLS_GLOBAL_HOOK__;
      } catch (e) {}

      if (t.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
        var i = t.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject;

        t.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = function (t) {
          n(this, r);
          t.Mount;
          i && i(t), e(t);
        }.bind(this);
      }
    }

    function i(t) {
      var r = this,
          i = t.Mount,
          o = t.Reconciler,
          c = i;
      e(o, {
        receiveComponent: function () {
          function t(t) {
            return n(this, r), function (e, i, o, u) {
              n(this, r), t.receiveComponent(e, i, o, u);
              var d = e._currentElement;

              if ((i !== d || u !== e._context) && e._currentElement && e._currentElement.type) {
                var s = a(e, c);
                f(s, e, !1);
              }
            }.bind(this);
          }

          return t;
        }().bind(this),
        mountComponent: function () {
          function t(t) {
            return n(this, r), function (e, i, o, a, c, d) {
              for (var s = arguments.length, l = Array(s > 6 ? s - 6 : 0), v = 6; v < s; v++) l[v - 6] = arguments[v];

              n(this, r);
              var p = t.mountComponent.apply(t, [e, i, o, a, c, d].concat(l));

              if ("string" == typeof p) {
                var _ = u(p);

                return _ ? (f(_, e, !0), _.outerHTML) : p;
              }

              return p.node && f(p.node, e, !0), p;
            }.bind(this);
          }

          return t;
        }().bind(this)
      });
    }

    function o(t) {
      var e = this;
      if ("string" == typeof t) return t;
      if (void 0 === t || null === t) return "";

      try {
        return JSON.stringify(t);
      } catch (r) {
        try {
          if (Array.isArray(t) && t.length > 0 && Array.isArray(t[0])) return JSON.stringify(t.map(function (t) {
            return n(this, e), t[0];
          }.bind(this)));
        } catch (r) {
          return "";
        }

        return "";
      }
    }

    function u(t) {
      var n = void 0;
      return n = t.startsWith("<tbody") || t.startsWith("<tfoot") || t.startsWith("<thead") ? document.createElement("table") : t.startsWith("<th") || t.startsWith("<td") ? document.createElement("tr") : t.startsWith("<tr") ? document.createElement("thead") : document.createElement("div"), n.innerHTML = t, n.childNodes[0];
    }

    function a(t, n) {
      var e = _(t);

      if (!e && "string" == typeof t._rootNodeID) try {
        e = n.getNode(t._rootNodeID);
      } catch (r) {
        return null;
      }
      return e;
    }

    function c(t) {
      return t._currentElement && t._currentElement.type ? t._currentElement.type.name : null;
    }

    function d(t, n, e) {
      return !n.startsWith("$$") && !n.startsWith("on") && "children" !== n && "data-tid-auto" !== n && "function" != typeof e;
    }

    function f(t, n, e) {
      if (t && "function" == typeof t.setAttribute) {
        var r = l({}, n);

        for (var i in r) t.setAttribute(i, r[i]);
      }
    }

    function s(t, e, r) {
      var i = this;

      if (null !== r) {
        var o = t[e],
            u = (o || "").split(" ").filter(function (t) {
          return n(this, i), "" !== t;
        }.bind(this));
        u.includes(r) || (t[e] = (o ? String(o) + " " : "") + r);
      }
    }

    function l(t, n) {
      t = v(t, n);
      var e = n._currentElement && n._currentElement._owner;
      return e && p(e, n) && (t = l(t, e)), t;
    }

    function v(t, n) {
      var e = n._currentElement && n._currentElement.props;

      if (c(n) && s(t, "data-comp-name", c(n)), e) {
        e["data-tid-auto"] && s(t, "data-tid-auto", e["data-tid-auto"]);

        for (var r in e) d(n, r, e[r]) && (t["data-prop-" + r] = o(e[r]));
      }

      return t;
    }

    function p(t, n) {
      if ("string" == typeof t._rootNodeID || "string" == typeof n._rootNodeID) {
        var e = t._rootNodeID,
            r = n._rootNodeID;
        if (null !== e && null !== r) return e === r;
      }

      var i = _(t),
          o = _(n);

      return null !== i && null !== o && i === o;
    }

    function _(t) {
      return t._hostNode ? t._hostNode : t._renderedComponent ? _(t._renderedComponent) : null;
    }

    t.ReactTesting = {
      addRenderContainer: function () {
        function t() {}

        return t;
      }(),
      removeRenderContainer: function () {
        function t() {}

        return t;
      }()
    }, r(i), document.addEventListener("keydown", function (t) {
      n(void 0, void 0), t.altKey && t.ctrlKey && t.shiftKey && "KeyH" == t.code ? (document.querySelectorAll(".tid-wrapper").forEach(function (t) {
        return n(void 0, void 0), t.remove();
      }.bind(void 0)), document.querySelectorAll("[data-tid-auto]").forEach(function (t) {
        return n(void 0, void 0), t.classList.remove("with-tid-wrapper");
      }.bind(void 0))) : t.altKey && t.ctrlKey && "KeyH" == t.code && (document.querySelectorAll(".tid-wrapper").forEach(function (t) {
        return n(void 0, void 0), t.remove();
      }.bind(void 0)), document.querySelectorAll("[data-tid-auto]").forEach(function (t) {
        n(void 0, void 0), t.classList.add("with-tid-wrapper");
        var e = document.createElement("div");
        e.classList.add("tid-wrapper"), e.innerHTML = "<div><div>" + t.getAttribute("data-tid-auto") + "</div></div>", e.addEventListener("click", function (t) {
          n(void 0, void 0);

          var e = function (r) {
            n(void 0, void 0), r.clipboardData.setData("text/plain", t.target.innerText), r.preventDefault(), document.removeEventListener("copy", e);
          }.bind(void 0);

          document.addEventListener("copy", e), document.execCommand("copy");
        }.bind(void 0)), t.appendChild(e);
      }.bind(void 0)));
    }.bind(void 0));
  }).call(n, e(0));
}]);